<p-panel header="Registro de {{titulo}}">
    <div class="ui-grid ui-fluid">
        <div class="ui-g-12">
            <form [formGroup]="modeloForm">
                <div class="ui-g form-group">
                    <div class="ui-g-12 ui-md-4">
                        <label class="label-custom" for="float-input-apepat">Apellido Paterno: </label>
                        <div class="ui-inputgroup">
                            <span class="ui-inputgroup-addon"><i class="fa fa-user"></i></span>
                            <input id="float-input-apepat" type="text" placeholder="Apellido Paterno" size="50" formControlName="apellidoPaterno" autocomplete="off" required pInputText>
                        </div>
                        <div *ngIf="modeloForm.controls['apellidoPaterno'].errors && modeloForm.controls['apellidoPaterno'].dirty">
                            <p-message severity="error" text="Apellido Paterno es requerido" *ngIf="modeloForm.controls['apellidoPaterno'].errors['required']"></p-message>
                            <p-message severity="error" text="Tener un min. de 2 y max. de 50 caractares" *ngIf="modeloForm.controls['apellidoPaterno'].errors['minlength'] || modeloForm.controls['apellidoPaterno'].errors['maxlength'] "></p-message>
                        </div>
                    </div>
                    <div class="ui-g-12 ui-md-4">
                        <label class="label-custom" for="float-input-apemat">Apellido Materno: </label>
                        <div class="ui-inputgroup">
                            <span class="ui-inputgroup-addon"><i class="fa fa-user"></i></span>
                            <input id="float-input-apemat" type="text" placeholder="Apellido Materno" size="50" formControlName="apellidoMaterno" autocomplete="off" required pInputText>
                        </div>
                        <div *ngIf="modeloForm.controls['apellidoMaterno'].errors && modeloForm.controls['apellidoMaterno'].dirty">
                            <p-message severity="error" text="Apellido Materno es requerido" *ngIf="modeloForm.controls['apellidoMaterno'].errors['required']"></p-message>
                            <p-message severity="error" text="Tener un min. de 2 y max. de 50 caractares" *ngIf="modeloForm.controls['apellidoMaterno'].errors['minlength'] || modeloForm.controls['apellidoMaterno'].errors['maxlength'] "></p-message>
                        </div>
                    </div>
                    <div class="ui-g-12 ui-md-4">
                        <label class="label-custom" for="float-input-nombre">Nombres: </label>
                        <div class="ui-inputgroup">
                            <span class="ui-inputgroup-addon"><i class="fa fa-user"></i></span>
                            <input id="float-input-nombre" type="text" placeholder="Nombres" size="50" formControlName="nombre" autocomplete="off" required pInputText>
                        </div>
                        <div *ngIf="modeloForm.controls['nombre'].errors && modeloForm.controls['nombre'].dirty">
                            <p-message severity="error" text="Nombre es requerido" *ngIf="modeloForm.controls['nombre'].errors['required']"></p-message>
                            <p-message severity="error" text="Tener un min. de 2 y max. de 50 caractares" *ngIf="modeloForm.controls['nombre'].errors['minlength'] || modeloForm.controls['nombre'].errors['maxlength'] "></p-message>
                        </div>
                    </div>
                    <div class="ui-g-12 ui-md-4">
                        <label class="label-custom" for="float-input-documento">Nro Documento: </label>
                        <div class="ui-inputgroup">
                            <span class="ui-inputgroup-addon"><i class="fa fa-file"></i></span>
                            <!-- <input id="float-input-documento" type="number" placeholder="Nro Documento" maxlength="20" formControlName="numeroDocumento" required pInputText> -->
                            <p-inputMask id="float-input-documento" mask="99999999" formControlName="numeroDocumento" placeholder="99999999" required></p-inputMask>
                        </div>
                        <div *ngIf="modeloForm.controls['numeroDocumento'].errors && modeloForm.controls['numeroDocumento'].dirty">
                            <p-message severity="error" text="Nro Documento es requerido" *ngIf="modeloForm.controls['numeroDocumento'].errors['required']"></p-message>
                        </div>
                    </div>
                    <div class="ui-g-12 ui-md-4">
                        <label class="label-custom" for="float-input-telefono">Nro Telefono: </label>
                        <div class="ui-inputgroup">
                            <span class="ui-inputgroup-addon"><i class="fa fa-mobile"></i></span>
                            <!-- <input id="float-input-telefono" type="number" placeholder="Nro Telefono" maxlength="20" formControlName="numeroTelefono" pInputText> -->
                            <p-inputMask id="float-input-telefono" mask="999999999" formControlName="numeroTelefono" placeholder="999999999"></p-inputMask>
                        </div>
                    </div>
                    <div class="ui-g-12 ui-md-4">
                        <label class="label-custom" for="float-input-estado">Estado: </label>
                        <div class="ui-inputgroup">
                            <p-checkbox [ngStyle]="{'padding-top': '5px'}" id="float-input-estado" [binary]="true" formControlName="flgEstado"></p-checkbox>
                        </div>
                    </div>
                    <div class="ui-g-12">
                        <p-fieldset legend="Credenciales Usuario">
                            <div class="ui-g-12 ui-md-2">
                                <label class="label-custom" for="float-input-usuario">Usuario: </label>
                                <div class="ui-inputgroup">
                                    <span class="ui-inputgroup-addon"><i class="fa fa-user"></i></span>
                                    <input id="float-input-usuario" type="text" placeholder="Usuario" formControlName="usuario" autocomplete="off" required pInputText>
                                </div>
                                <div *ngIf="modeloForm.controls['usuario'].errors && modeloForm.controls['usuario'].dirty">
                                    <p-message severity="error" text="Usuario es requerido" *ngIf="modeloForm.controls['usuario'].errors['required']"></p-message>
                                    <p-message severity="error" text="Tener un min. de 2 y max. de 20 caractares" *ngIf="modeloForm.controls['usuario'].errors['minlength'] || modeloForm.controls['usuario'].errors['maxlength'] "></p-message>
                                </div>
                            </div>
                            <div class="ui-g-12 ui-md-3">
                                <label class="label-custom">Contraseña: </label>
                                <div class="ui-inputgroup">
                                    <span class="ui-inputgroup-addon"><i class="fa fa-user"></i></span>
                                    <input type="text" placeholder="" formControlName="password" autocomplete="off" required pInputText>
                                </div>
                                <div *ngIf="modeloForm.controls['password'].errors && modeloForm.controls['password'].dirty">
                                    <p-message severity="error" text="Contraseña es requerido" *ngIf="modeloForm.controls['password'].errors['required']"></p-message>
                                    <p-message severity="error" text="Tener un min. de 6 y max. de 50 caractares" *ngIf="modeloForm.controls['password'].errors['minlength'] || modeloForm.controls['password'].errors['maxlength'] "></p-message>
                                </div>
                            </div>
                            <div class="ui-g-12 ui-md-4">
                                <label class="label-custom" for="float-input-email">Email: </label>
                                <div class="ui-inputgroup">
                                    <span class="ui-inputgroup-addon"><i class="fa fa-envelope"></i></span>
                                    <input id="float-input-email" type="email" placeholder="Email" pInputText formControlName="email" autocomplete="off" required>
                                </div>
                                <div *ngIf="modeloForm.controls['email'].errors && modeloForm.controls['email'].dirty">
                                    <p-message severity="error" text="Email es requerido" *ngIf="modeloForm.controls['email'].errors['required']"></p-message>
                                </div>
                            </div>
                            <div class="ui-g-12 ui-md-3">
                                <label class="label-custom" for="float-input-perfil">Perfil: </label>
                                <p-dropdown id="float-input-perfil" [options]="listItemPerfil" class="ui dropdown-item-text" placeholder="Elegir Perfil" formControlName="perfil" required optionLabel="label" [showClear]="true"></p-dropdown>
                                <div *ngIf="modeloForm.controls['perfil'].errors && modeloForm.controls['perfil'].dirty">
                                    <p-message severity="error" text="Perfil es requerido" *ngIf="modeloForm.controls['perfil'].errors['required']"></p-message>
                                </div>
                            </div>

                            <div class="ui-g-12 ui-md-5">
                                <label class="label-custom" for="float-input-unidad">Acceso a la unidad: </label>
                                <div class="ui-inputgroup">
                                    <span class="ui-inputgroup-addon"><i class="fa fa-cog"></i></span>
                                    <p-dropdown id="float-input-unidad" [options]="listItemUnidad" class="ui dropdown-item-text"  formControlName="unidad" required optionLabel="label" [showClear]="true"></p-dropdown>
                                </div>
                            </div>

                        </p-fieldset>
                        <p-fieldset legend="Datos Adicionales">
                            <p-fieldset legend="Foto" [toggleable]="true" [collapsed]="true">
                                <div class="ui-g-12 ui-md-4">
                                    <img [src]="sellersPermitString" style="width: 100%; display: block;">
                                </div>
                                <div class="ui-g-12 ui-md-8">
                                    <p-fileUpload name="demo[]" chooseLabel="Seleccionar" cancelLabel="Cancelar" accept="image/*" [showUploadButton]="false" (onSelect)="onBasicUpload($event)" (onClear)="onClearUpload()">
                                    </p-fileUpload>
                                </div>
                            </p-fieldset>
                            <p-fieldset legend="Light or Dark" [toggleable]="true" [collapsed]="true">
                                <div class="ui-g-12 ui-md-4">
                                    <a style="cursor: pointer" (click)="changeDarkOrLight(false)">
                                        <img src="assets/layout/images/configurator/menu/apollo-static.png" alt="apollo" />
                                        <i class="fa fa-check" *ngIf="!app.darkTheme"></i>
                                    </a>
                                </div>
                            </p-fieldset>
                            <p-fieldset legend="Menu" [toggleable]="true" [collapsed]="true">
                                <div class="ui-g-12 ui-md-4">
                                    <a style="cursor: pointer" (click)="app.menuMode = 'static'">
                                        <img src="assets/layout/images/configurator/menu/apollo-static.png" alt="apollo" />
                                        <i class="fa fa-check" *ngIf="app.menuMode === 'static'"></i>
                                    </a>
                                    <span>Static</span>
                                </div>
                            </p-fieldset>
                            <p-fieldset legend="Themes" [toggleable]="true" [collapsed]="true">
                                <div class="panel-items">
                                    <div class="panel-item" *ngFor="let theme of themes">
                                        <div class="ui-g-12 ui-md-1">
                                            <a style="cursor: pointer" class="layout-config-layout-option" (click)="app.changeTheme(theme.label)">
                                                <img src="assets/layout/images/configurator/themes/{{theme.label}}.svg" alt="apollo" />
                                                <i class="fa fa-check" *ngIf="app.selectedColor === theme.label"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </p-fieldset>
                        </p-fieldset>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <p-footer>
        <div class="ui-grid ui-fluid">
            <div class="ui-g-12 ui-md-6">
                <button pButton type="submit" [disabled]="!modeloForm.valid" label="{{globalConstants.cGrabar}}" icon="{{globalConstants.icoGrabar}}" (click)="onClickSave()"></button>
            </div>
            <div class="ui-g-12 ui-md-6">
                <button pButton type="button" label="{{globalConstants.cRegresar}}" icon="{{globalConstants.icoRegresar}}" (click)="back()"></button>
            </div>
        </div>
    </p-footer>
</p-panel>

<p-dialog header="Grabar" [(visible)]="displayGrabar" [closable]="false" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">

    Guardando datos...!!!
    <div class="ui-g ui-fluid">
        <div class="ui-g-12">
            <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
        </div>
    </div>

</p-dialog>